export const COLORES = [
  { value: 'ROJO', text: 'Rojo', hex: '#FF0909' },
  { value: 'CELESTE', text: 'Celeste', hex: '#2E64FE' },
  { value: 'CAFE', text: 'Cafe', hex: '#61380B' },
  { value: 'AMARILLO', text: 'Amarillo', hex: '#F4FA58' },
  { value: 'AZUL', text: 'Azul', hex: '#0000FF' },
  { value: 'NEGRO', text: 'Negro', hex: '#000000' },
  { value: 'ROSADO', text: 'Rosado', hex: '#FF00BF' },
  { value: 'VERDE', text: 'Verde', hex: '#088A08' },
];

export const MASCOTAS = [
  { value: 'MONO', text: 'Mono', icon: './assets/images/mascotas/mono.jpeg' },
  { value: 'PATO', text: 'Pato', icon: './assets/images/mascotas/pato.jpeg' },
  {
    value: 'HAMSTER',
    text: 'Hamster',
    icon: './assets/images/mascotas/hamster.jpeg',
  },
  {
    value: 'TORTUGA',
    text: 'Tortuga',
    icon: './assets/images/mascotas/tortuga.jpeg',
  },
  {
    value: 'PERRO',
    text: 'Perro',
    icon: './assets/images/mascotas/perro.jpeg',
  },
  {
    value: 'CONEJO',
    text: 'Conejo',
    icon: './assets/images/mascotas/conejo.jpeg',
  },
  { value: 'PEZ', text: 'Pez', icon: './assets/images/mascotas/pez.jpeg' },
  { value: 'GATO', text: 'Gato', icon: './assets/images/mascotas/gato.jpeg' },
];

export const FRUTAS = [
  {
    value: 'SANDIA',
    text: 'Sandia',
    icon: './assets/images/frutas/sandia.jpeg',
  },
  { value: 'PERA', text: 'Pera', icon: './assets/images/frutas/pera.jpeg' },
  {
    value: 'FRUTILLA',
    text: 'Frutilla',
    icon: './assets/images/frutas/frutilla.jpeg',
  },
  {
    value: 'BANANA',
    text: 'Banana',
    icon: './assets/images/frutas/banana.jpeg',
  },
  { value: 'UVA', text: 'Uva', icon: './assets/images/frutas/uva.jpeg' },
  { value: 'PIÑA', text: 'Piña', icon: './assets/images/frutas/piña.jpeg' },
  {
    value: 'NARANJA',
    text: 'Naranja',
    icon: './assets/images/frutas/naranja.jpeg',
  },
  {
    value: 'MANZANA',
    text: 'Manzana',
    icon: './assets/images/frutas/manzana.jpeg',
  },
];
